import { PublicClientApplication, Configuration, LogLevel } from '@azure/msal-browser'
import Param from '@/lib/definition/variables'

const site = Param.Site as Record<string, string>

const msalConfig: Configuration = {
  auth: {
    clientId: site.entraClientId || '',
    authority: `https://login.microsoftonline.com/${site.entraTenantId || 'common'}`,
    redirectUri: window.location.origin
  },
  cache: {
    cacheLocation: 'sessionStorage'
  },
  system: {
    loggerOptions: {
      logLevel: LogLevel.Warning
    }
  }
}

export const msalInstance = new PublicClientApplication(msalConfig)

export const loginRequest = {
  scopes: ['openid', 'profile', 'email']
}
